import { render, staticRenderFns } from "./ButtonVPN.vue?vue&type=template&id=7ad3a5a6"
import script from "./ButtonVPN.vue?vue&type=script&lang=js"
export * from "./ButtonVPN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports